import React, { Component } from "react";
import { gql } from "@apollo/client";
import Spinner from "react-bootstrap/Spinner";

import { apolloClient } from "../../index";
import "./DocumentTemplates.scss";
import ListViewRows from "../../components/ListView/ListViewRows/ListViewRows";
import ListViewHeader from "../../components/ListView/ListViewHeader/ListViewHeader";
import CreateNewTemplate from "../../components/DocumentTemplate/CreateNewTemplate/CreateNewTemplate";
import TemplateModal from "../../components/UI/TemplateModal/TemplateModal";
import NewTemplate from "../../components/DocumentTemplate/NewTemplate/NewTemplate";
import ViewTemplate from "../../components/DocumentTemplate/NewTemplate/ViewTemplate";

import { notify } from "../../components/Notify/Notify";
import DeleteTemplate from "../../components/DocumentTemplate/DeleteTemplate/DeleteTemplate";
import EmptyStates from "../../components/EmptyStates/EmptyStates";
import emptyDocumentImage from "../../assets/EmptyStates/empty_template.svg";

class DocumentTemplates extends Component {
  state = {
    heading: ["Document Type", "Status", "Created On", "Description"],
    isLoading: true,
    documentTemplates: [],
    isColumns: {
      isDocumentType: true,
      isStatus: true,
      isCreatedOn: true,
      isDescription: true,
      isDropDown: true,
    },
    tableSizeLarge: true,
    isVisible: false,
    statusId: null,
    statusName: "",
    documentType: "",
    showDeleteModal: false,
    deleteTemplateId: null,
    deleteTemplateTitle: "",
    displayCreateModal: false,
    displayViewModal: false,
    showModal: false,
    documentDescription: "",
    documentTypeName: "",
    content: [],
    editTemplate: false,
    editTemplateId: null,
    errorMessage: "",
    isViewModal: false,
    templateTitle: "",
    autoSave: false,
    autoSaveFlag: true,
    stopUpdate: false,
    updateBackendFlag: false,
    searchString: "",
  };

  // updateBackendFlag : for create/update template. true (call upate template code ) / false (call create temp code)
  // Get the list of all document template on component mount.
  componentDidMount() {
    apolloClient
      .query({
        query: gql`
          query templatesOfCustomer {
            templatesOfCustomer {
              id
              title
              description
              abstractJson
              status {
                id
                name
              }
              createdTs
            }
          }
        `,
        variables: {},
      })
      .then((result) => {
        if (result.data.templatesOfCustomer.length > 0) {
          this.setState({
            isLoading: false,
            documentTemplates: JSON.parse(
              JSON.stringify(result.data.templatesOfCustomer)
            ),
          });
        }
      })
      .catch((e) => {
        this.setState({ isLoading: false, documentTemplates: [] });
      });
  }

  // Change the Status of the Document Template
  setStatus = (id, status, documentType) => {
    this.setState({
      isVisible: true,
      statusId: id,
      statusName: status,
      documentType: documentType,
    });
  };

  statusHandler = (event, id) => {
    event.preventDefault();
    let UpdatedDocumentTemplates = [...this.state.documentTemplates];
    let UpdatedDocumentTemplate = UpdatedDocumentTemplates.filter(
      (item) => item.id === id
    )[0];
    const templateName = UpdatedDocumentTemplate.title;
    let status;
    if (UpdatedDocumentTemplate.status.name === "Draft") {
      let content = JSON.parse(UpdatedDocumentTemplate.abstractJson);
      let errors = [];

      const restrictedTitle = ["overview", "comment", "notes"];
      let allTabName = [];
      content.map((tabItem) => allTabName.push(tabItem.tabTitle));
      content.map((tab) => {
        const restrictedTabErrorId = tab.tabId + "restricted";
        const uniqueTabErrorId = tab.tabId + "unique";
        errors[restrictedTabErrorId] = restrictedTitle.includes(
          tab.tabTitle.toLowerCase()
        )
          ? true
          : false;
        errors[uniqueTabErrorId] =
          allTabName.filter(
            (tabName) => tabName.toLowerCase() === tab.tabTitle.toLowerCase()
          ).length > 1
            ? true
            : false;
        errors[tab.tabId] = tab.tabTitle === "Tab Name" ? true : false;
        tab.tabSections.map((section) => {
          errors[section.sectionId] =
            section.sectionTitle.length > 0 ? false : true;
          section.sectionFields.map((field) => {
            errors[field.fieldId] = field.fieldLabel.length > 0 ? false : true;

            field.options &&
              field.options.map((option) => {
                errors[option.optionId] =
                  option.optionValue.length > 0 ? false : true;
                return true;
              });
            return true;
          });
          return true;
        });
        return true;
      });
      let isValid = true;
      Object.keys(errors).map((item) => {
        if (errors[item]) {
          isValid = false;
        }
        return true;
      });

      if (isValid) {
        status = 1;
      } else {
        this.setState({
          isVisible: false,
        });
        const title = "Error";
        // const detail = templateName + " template status not changed!";
        const detail = "Template is incomplete. Please edit and save.";
        const type = "error";
        notify(title, detail, type);
        return;
      }
    } else {
      status = 2;
    }
    const variables = {
      documentTypeId: id,
      status: status,
    };

    apolloClient
      .mutate({
        mutation: gql`
          mutation updateTemplateStatus($documentTypeId: UUID!, $status: Int!) {
            updateTemplateStatus(
              documentTypeId: $documentTypeId
              status: $status
            ) {
              success
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        const success = result.data.updateTemplateStatus.success;

        // changes in frontend on success
        if (success) {
          let documentTemplate = UpdatedDocumentTemplates.map((item) => {
            let resultItem = item;
            if (resultItem.id === id) {
              resultItem.status.name === "Draft"
                ? (resultItem.status.name = "Active")
                : (resultItem.status.name = "Draft");
            }
            return resultItem;
          });

          // update state
          this.setState({
            documentTemplates: documentTemplate,
            isVisible: false,
          });

          // Toast message
          const title = "Success";
          const detail = templateName + " status changed successfully!";
          const type = "success";
          notify(title, detail, type);
        }
      })
      .catch((e) => {
        // Toast message
        const title = "Error";
        // const detail = templateName + " template status not changed!";
        const detail = "Oops!! some error occurred please try again.";
        const type = "error";
        notify(title, detail, type);
      });
  };

  // Open the create a new template modal
  handleOpen = () => {
    this.setState({
      showModal: true,
      documentDescription: "",
      documentTypeName: "",
      updateBackendFlag: false,
    });
  };

  // Close the create a new template modal
  handleClose = () => {
    this.setState({ showModal: false });
  };

  // Update the value of the template name and description
  handleInputValueChange = (event) => {
    let UpdatedDocumentTemplates = [...this.state.documentTemplates];
    let UpdatedDocumentTemplate = [
      ...UpdatedDocumentTemplates.filter(
        (item) => item.title.toLowerCase() === event.target.value.toLowerCase()
      ),
    ];
    this.setState({ [event.target.name]: event.target.value });
    // Validate template not exists with this name.
    if (event.target.name === "documentTypeName") {
      if (UpdatedDocumentTemplate.length > 0) {
        this.setState({
          errorMessage: "Template name already exists.",
        });
      } else {
        this.setState({
          errorMessage: "",
        });
      }
    }
  };
  // Validate the Type name and description field.
  hasValidValues = () => {
    let UpdatedDocumentTemplates = [...this.state.documentTemplates];
    let UpdatedDocumentTemplate = [
      ...UpdatedDocumentTemplates.filter(
        (item) => item.title === this.state.documentTypeName
      ),
    ];
    if (this.state.documentTypeName.trim().length > 0) {
      if (UpdatedDocumentTemplate.length === 0) {
        if (this.state.documentDescription.length > 0) {
          return true;
        }
        return false;
      }
      return false;
    }
    return false;
  };
  // Redirect to the new template modal.
  handleSave = () => {
    if (this.hasValidValues()) {
      this.setState({
        showModal: false,
        displayCreateModal: true,
        autoSave: true,
      });
    }
  };

  // Close the new template modal.
  templateCloseHandler = () => {
    this.setState({
      content: [],
      displayCreateModal: false,
      editTemplate: false,
      autoSave: false,
      autoSaveFlag: true,
      stopUpdate: false,
    });
  };

  templateViewCloseHandler = () => {
    this.setState(
      {
        displayViewModal: false,
        editTemplate: false,
      },
      () => {
        this.setState({ content: [] });
      }
    );
  };
  // Create or Update template in a backend.
  updateTemplateBackend = (
    event,
    newContent,
    title,
    templateDescription,
    status
  ) => {
    event.preventDefault();
    // check if it's new template or update old template.
    if (this.state.updateBackendFlag) {
      // Update the template.
      let templateName;
      let UpdatedDocumentTemplates = [...this.state.documentTemplates];
      if (title) {
        templateName = title;
      } else {
        UpdatedDocumentTemplates.map((item) => {
          if (item.id === this.state.editTemplateId) {
            templateName = item.title;
          }
          return true;
        });
      }
      const variables = {
        title: templateName,
        description: templateDescription,
        statusId: status,
        documentTypeId: this.state.editTemplateId,
        abstractData: JSON.stringify(newContent),
      };
      event.target.value === "updateAll" ? variables["updateAll"] = true : variables["updateAll"] = false
      apolloClient
        .mutate({
          mutation: gql`
            mutation updateDocumentTemplate(
              $title: String!
              $description: String!
              $documentTypeId: UUID!
              $statusId: Int!
              $abstractData: String!
              $updateAll: Boolean!
            ) {
              updateDocumentTemplate(
                title: $title
                description: $description
                documentTypeId: $documentTypeId
                statusId: $statusId
                abstractData: $abstractData
                updateAll: $updateAll
              ) {
                success
              }
            }
          `,
          variables: variables,
        })
        .then((result) => {
          const success = result.data.updateDocumentTemplate.success;
          // Change in frontend on backend success.
          if (success) {
            const documentTemplate = UpdatedDocumentTemplates.map((item) => {
              let resultItem = item;
              if (resultItem.id === this.state.editTemplateId) {
                resultItem.title = templateName;
                resultItem.description = templateDescription;
                resultItem.abstractJson = JSON.stringify(newContent);
                if (status === 1) {
                  resultItem.status.name = "Active";
                } else {
                  resultItem.status.name = "Draft";
                }
              }
              return resultItem;
            });

            // Update the state
            this.setState({
              documentTemplates: documentTemplate,
            });

            // Toast message
            const title = "Success";
            const detail =
              status === 1
                ? templateName + " is updated successfully!"
                : templateName + " is saved to draft successfully!";
            const type = "success";
            notify(title, detail, type);
          }
        })
        .catch((e) => {
          // Toast message
          const title = "Error";
          const detail = "Oops!! some error occurred please try again.";
          const type = "error";
          notify(title, detail, type);
        });
    } else {
      // Create a new template.
      const templateName = this.state.documentTypeName;
      const variables = {
        title: title,
        description: templateDescription,
        statusId: status,
        abstractData: JSON.stringify(newContent),
      };

      apolloClient
        .mutate({
          mutation: gql`
            mutation createDocumentTemplate(
              $title: String!
              $description: String!
              $statusId: Int!
              $abstractData: String!
            ) {
              createDocumentTemplate(
                title: $title
                description: $description
                statusId: $statusId
                abstractData: $abstractData
              ) {
                documentType {
                  id
                  title
                  description
                  abstractJson
                  status {
                    id
                    name
                  }
                  createdTs
                }
                success
              }
            }
          `,
          variables: variables,
        })
        .then((result) => {
          const success = result.data.createDocumentTemplate.success;

          // Change in frontend on backend success.
          if (success) {
            let newTemplate = JSON.parse(
              JSON.stringify(result.data.createDocumentTemplate.documentType)
            );
            let updateDocumentTemplates = [
              newTemplate,
              ...this.state.documentTemplates,
            ];

            // Update the state
            this.setState({
              documentTemplates: updateDocumentTemplates,
            });

            // Toast message
            const title = "Success";
            const detail =
              status === 1
                ? templateName + " is created successfully!"
                : templateName + " is saved to draft successfully!";
            const type = "success";
            notify(title, detail, type);
          }
        })
        .catch((e) => {
          // Toast message
          const title = "Error";
          // const detail = templateName + " template not created";
          const detail = "Oops!! some error occurred please try again.";
          const type = "error";
          notify(title, detail, type);
        });
    }

    // update the state on update or create.
    this.setState({
      displayCreateModal: false,
      editTemplate: false,
      content: [],
      updateBackendFlag: false,
    });
  };

  // Save template as the Draft.
  templateSaveDraftHandler = (
    event,
    newContent,
    title,
    templateDescription
  ) => {
    this.setState({
      autoSave: false,
      autoSaveFlag: true,
      stopUpdate: false,
    });
    const status = 2;
    if (this.state.updateBackendFlag) {
      this.updateTemplateBackend(
        event,
        newContent,
        title,
        templateDescription,
        status
      );
    } else {
      this.updateTemplateBackend(
        event,
        newContent,
        title,
        templateDescription,
        status
      );
    }
  };

  templateAutoSaveHandler = (
    newContent,
    documentTitle,
    documentDescription,
    templateStatus,
    flag
  ) => {
    const status = templateStatus;
    if (!flag) {
      // Update the template
      const variables = {
        documentTypeId: this.state.editTemplateId,
        statusId: status,
        title: documentTitle,
        description: documentDescription,
        abstractData: JSON.stringify(newContent),
        updateAll: false
      };
      let UpdatedDocumentTemplates = [...this.state.documentTemplates];
      UpdatedDocumentTemplates.filter(
        (item) => item.id === this.state.editTemplateId
      );
      apolloClient
        .mutate({
          mutation: gql`
            mutation updateDocumentTemplate(
              $documentTypeId: UUID!
              $title: String!
              $description: String!
              $statusId: Int!
              $abstractData: String!
              $updateAll: Boolean!
            ) {
              updateDocumentTemplate(
                documentTypeId: $documentTypeId
                title: $title
                description: $description
                statusId: $statusId
                abstractData: $abstractData
                updateAll: $updateAll
              ) {
                success
              }
            }
          `,
          variables: variables,
        })
        .then((result) => {
          const success = result.data.updateDocumentTemplate.success;

          // Change in frontend on backend success.
          if (success) {
            const documentTemplate = UpdatedDocumentTemplates.map((item) => {
              let resultItem = item;
              if (resultItem.id === this.state.editTemplateId) {
                resultItem.abstractJson = JSON.stringify(newContent);
                resultItem.title = documentTitle;
                resultItem.description = documentDescription;
                if (status === 1) {
                  resultItem.status.name = "Active";
                } else {
                  resultItem.status.name = "Draft";
                }
              }
              return resultItem;
            });
            // Update the state
            this.setState({
              documentTemplates: documentTemplate,
              autoSaveFlag: false,
              stopUpdate: true,
            });
          }
        })
        .catch((e) => {
          const title = "Error";
          const detail = "Oops!! some error occurred please try again.";
          const type = "error";
          notify(title, detail, type);
        });
    } else {
      // Create a new template.
      const variables = {
        title: documentTitle,
        description: documentDescription,
        statusId: status,
        abstractData: JSON.stringify(newContent),
      };

      apolloClient
        .mutate({
          mutation: gql`
            mutation createDocumentTemplate(
              $title: String!
              $description: String!
              $statusId: Int!
              $abstractData: String!
            ) {
              createDocumentTemplate(
                title: $title
                description: $description
                statusId: $statusId
                abstractData: $abstractData
              ) {
                documentType {
                  id
                  title
                  description
                  abstractJson
                  status {
                    id
                    name
                  }
                  createdTs
                }
                success
              }
            }
          `,
          variables: variables,
        })
        .then((result) => {
          const success = result.data.createDocumentTemplate.success;

          // Change in frontend on backend success.
          if (success) {
            let newTemplate = JSON.parse(
              JSON.stringify(result.data.createDocumentTemplate.documentType)
            );
            let updateDocumentTemplates = [
              newTemplate,
              ...this.state.documentTemplates,
            ];
            // Update the state
            this.setState({
              documentTemplates: updateDocumentTemplates,
              editTemplateId: newTemplate.id,
              autoSaveFlag: false,
              stopUpdate: true,
              updateBackendFlag: true,
            });
          }
        })
        .catch((e) => {
          // Toast message
          const title = "Error";
          // const detail = templateName + " template not created";
          const detail = "Oops!! some error occurred please try again.";
          const type = "error";
          notify(title, detail, type);
        });
    }
  };

  // Save the template as the active.
  templateCreateHandler = (event, newContent, title, templateDescription) => {
    this.setState({
      autoSave: false,
      autoSaveFlag: true,
      stopUpdate: false,
    });
    const status = 1;
    if (this.state.updateBackendFlag) {
      this.updateTemplateBackend(
        event,
        newContent,
        title,
        templateDescription,
        status
      );
    } else {
      this.updateTemplateBackend(
        event,
        newContent,
        title,
        templateDescription,
        status
      );
    }
  };

  // Edit the Template.
  templateEditHandler = (event, id) => {
    event.preventDefault();
    let UpdatedDocumentTemplate = this.state.documentTemplates.filter(
      (item) => item.id === id
    )[0];
    // Update the state.
    this.setState({
      content: JSON.parse(UpdatedDocumentTemplate.abstractJson),
      displayCreateModal: true,
      editTemplate: true,
      editTemplateId: id,
      displayViewModal: false,
      autoSave: true,
      autoSaveFlag: true,
      updateBackendFlag: true,
      documentDescription: UpdatedDocumentTemplate.description,
      documentTypeName: UpdatedDocumentTemplate.title,
    });
  };

  // Delete the Template.
  templateDeleteOpenHandler = (id, title) => {
    this.setState({
      deleteTemplateId: id,
      deleteTemplateTitle: title,
      showDeleteModal: true,
    });
  };

  templateDeleteCloseHandler = () => {
    this.setState({
      deleteTemplateId: null,
      deleteTemplateTitle: "",
      showDeleteModal: false,
    });
  };

  templateDeleteHandler = (event) => {
    event.preventDefault();
    const id = this.state.deleteTemplateId;
    const templateName = this.state.deleteTemplateTitle;
    let UpdatedDocumentTemplates = [...this.state.documentTemplates];
    let index = UpdatedDocumentTemplates.findIndex((item) => item.id === id);

    const variables = {
      documentTypeId: id,
    };

    apolloClient
      .mutate({
        mutation: gql`
          mutation deleteDocumentTemplate($documentTypeId: UUID!) {
            deleteDocumentTemplate(documentTypeId: $documentTypeId) {
              success
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        const success = result.data.deleteDocumentTemplate.success;
        // Change in the frontend on backend success.
        if (success) {
          UpdatedDocumentTemplates.splice(index, 1);

          // Update the state
          this.setState({
            documentTemplates: UpdatedDocumentTemplates,
            deleteTemplateId: null,
            deleteTemplateTitle: "",
            showDeleteModal: false,
            displayViewModal: false,
          });

          // Toast message
          const title = "Success";
          const detail = templateName + " is deleted successfully!";
          const type = "success";
          notify(title, detail, type);
        }
      })
      .catch((e) => {
        // Toast message
        const title = "Error";
        // const detail = templateName + "template not deleted!";
        const detail = "Oops!! some error occurred please try again.";
        const type = "error";
        notify(title, detail, type);
      });
  };

  handleRowClick = (event, id, title, discription) => {
    event.preventDefault();
    let UpdatedDocumentTemplate = this.state.documentTemplates.filter(
      (item) => item.id === id
    )[0];
    // Update the state.
    this.setState({
      content: JSON.parse(UpdatedDocumentTemplate.abstractJson),
      displayViewModal: true,
      editTemplate: true,
      editTemplateId: id,
      templateTitle: title,
      documentTypeName: title,
      documentDescription: discription,
    });
  };

  getSearchFilteredTemplates = () =>
    this.state.documentTemplates.filter((template) =>
      template.title.toLowerCase().includes(this.state.searchString.trim().toLowerCase())
    );

  render() {
    //buttons for empty state when document template is empty
    const emptyStateButtons = [
      {
        buttonName: "Create Template",
        clickMethod: this.handleOpen,
      },
    ];

    return (
      <div className="document-template-wraper">
        <div className="document-template-header d-flex">
          {
            this.state.documentTemplates.length !== 0 ? (
              <div className="search-filter-container">
                <div className="search-box mr-2">
                  <input
                    type="text"
                    maxLength="50"
                    placeholder="&#xF002;  Search Document Template"
                    className="search-placeholder set-width"
                    value={this.state.searchString}
                    onChange={(e) => {
                      this.setState({ searchString: e.target.value });
                      // handleFilterTags();
                    }}
                  />
                </div>
              </div>
            ) : null
          }
          <div className="ml-auto">
            {/* Modal for the Template name and description */}
            <CreateNewTemplate
              errorMessage={this.state.errorMessage}
              handleOpen={this.handleOpen}
              handleClose={this.handleClose}
              handleInputValueChange={this.handleInputValueChange}
              hasValidValues={!this.hasValidValues()}
              handleSaveDraft={this.handleSaveDraft}
              handleSave={this.handleSave}
              showModal={this.state.showModal}
              documentTypeName={this.state.documentTypeName}
              documentDescription={this.state.documentDescription}
              length={this.state.documentTemplates.length}
              isLoading={this.state.isLoading}
            />
          </div>
        </div>
        <div className="table-responsive document-templates-list">
          {this.state.isLoading ? (
            <div className="progress-icon" style={{ textAlign: "center" }}>
              <Spinner animation="border" role="status" />
            </div>
          ) : this.getSearchFilteredTemplates().length > 0 ? (
            <table className="table table-hover">
              <thead>
                <tr className="folderlist-header table-borderless">
                  {this.state.heading.map((headKey) => (
                    <ListViewHeader
                      key={headKey}
                      columnName={headKey}
                      checked={this.state.selectAll}
                    />
                  ))}
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.getSearchFilteredTemplates().map((rKey) => (
                  <ListViewRows
                    key={rKey.id}
                    item={rKey}
                    isColumns={this.state.isColumns}
                    size={this.state.tableSizeLarge}
                    setStatus={this.setStatus}
                    isDocumentTemplate={true}
                    statusHandler={this.setStatus}
                    templateEditHandler={this.templateEditHandler}
                    templateDeleteOpenHandler={this.templateDeleteOpenHandler}
                    status={this.state.statusName}
                    documentType={this.state.documentType}
                    click={(e) => {
                      this.handleRowClick(
                        e,
                        rKey.id,
                        rKey.title,
                        rKey.description
                      );
                    }}
                    {...this.props}
                  />
                ))}
              </tbody>
            </table>
          ) : (
            // No document template screen.
            <div className="no-document-templates is-size-h2 bold">
              {/* Add Document Template from Create New */}
              <EmptyStates
                imgSrc={emptyDocumentImage}
                emptyStateTitle={this.state.documentTemplates.length === 0 ? "Create a template and start standardizing your document tracking!" : "No results found !"}
                breakLine={this.state.documentTemplates.length === 0 ? "your" : null}
                description={this.state.documentTemplates.length === 0 ? null : "Please try again using different filters or search terms"}
                emptyStateButtons={this.state.documentTemplates.length === 0 ? emptyStateButtons || [] : []}
                {...this.props}
              />
            </div>
          )}
        </div>

        {/* Modal for the Template status update */}
        <TemplateModal
          showModal={this.state.isVisible}
          handleClose={() => {
            this.setState({ isVisible: !this.state.isVisible });
          }}
          statusHandler={this.statusHandler}
          documentId={this.state.statusId}
          status={this.state.statusName}
          documentType={this.state.documentType}
        />
        <DeleteTemplate
          showDeleteModal={this.state.showDeleteModal}
          templateDeleteCloseHandler={this.templateDeleteCloseHandler}
          documentType={this.state.deleteTemplateTitle}
          templateDeleteHandler={(event) => this.templateDeleteHandler(event)}
        />
        {/* Modal for the Template create or update */}

        {/* ViewTemplate */}

        <ViewTemplate
          content={this.state.content}
          templateViewCloseHandler={this.templateViewCloseHandler}
          displayViewModal={this.state.displayViewModal}
          editTemplate={this.state.editTemplate}
          templateDeleteOpenHandler={this.templateDeleteOpenHandler}
          editTemplateId={this.state.editTemplateId}
          templateTitle={this.state.templateTitle}
          templateEditHandler={this.templateEditHandler}
        />

        <NewTemplate
          content={this.state.content}
          templateCloseHandler={this.templateCloseHandler}
          templateSaveDraftHandler={this.templateSaveDraftHandler}
          templateCreateHandler={this.templateCreateHandler}
          displayCreateModal={this.state.displayCreateModal}
          editTemplate={this.state.editTemplate}
          autoSave={this.state.autoSave}
          autoSaveFlag={this.state.autoSaveFlag}
          templateAutoSaveHandler={this.templateAutoSaveHandler}
          stopUpdate={this.state.stopUpdate}
          templateTitle={this.state.documentTypeName}
          documentDescription={this.state.documentDescription}
          handleInputValueChange={this.handleInputValueChange}
          DocumentTemplates={this.state.documentTemplates}
        />
      </div>
    );
  }
}

export default DocumentTemplates;
